import React, {useMemo} from "react"

import PropTypes from "prop-types"
import {Radio, Button as SemanticButton} from "semantic-ui-react"

import {getDataTestId} from "../../utils/stringUtil"

import "./boxedRadioButton.scss"

const BoxedRadioButton = ({
    checked = false,
    children,
    className = null,
    dataTestId = undefined,
    disabled = false,
    height = undefined,
    id = undefined,
    name = undefined,
    width = undefined,
    ...props
}) => {
    const buttonId = useMemo(
        () => id || `boxed-radio-${name}-${dataTestId || getDataTestId(children, "bouton")}`,
        [id, name, dataTestId, children],
    )

    const style = useMemo(() => {
        let style = {}
        if (width) {
            style.width = width + "rem"
        }

        if (height) {
            style.height = height + "rem"
        }

        return style
    }, [height, width])

    return (
        <SemanticButton
            aria-checked={checked}
            aria-label={typeof children === "string" ? children : undefined}
            basic
            className={`${className}${checked ? " selected" : ""} boxed-radio-button`}
            data-testid={dataTestId || getDataTestId(children, "bouton")}
            disabled={disabled}
            id={buttonId}
            role="radio"
            style={style}
            type="button"
            {...props}
        >
            <Radio checked={checked} disabled={disabled} tabIndex={-1} />
            <div className="button-basic-children">{children}</div>
        </SemanticButton>
    )
}

BoxedRadioButton.propTypes = {
    checked: PropTypes.bool,
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    disabled: PropTypes.bool,
    height: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func,
    width: PropTypes.string,
}

export default BoxedRadioButton
